import { useEffect, useRef, useState } from 'react';

const useHorizontalScrollHelpers = () => {
  const [scrollXOffset, setScrollXOffset] = useState(0);
  const [ticking, setTicking] = useState<number>(0);
  const scrollElement: any = useRef();

  useEffect(() => {
    setTicking(0);
  }, [scrollXOffset]);

  const calculateScrollOffset = () => {
    if (!scrollElement?.current) return;

    const newOffset = scrollElement.current.scrollLeft;

    if (scrollXOffset === newOffset) {
      setTicking(0);
      return;
    }

    setScrollXOffset(scrollElement.current.scrollLeft);
  };

  const onScroll = () => {
    if (!ticking) {
      setTicking(requestAnimationFrame(calculateScrollOffset));
    }
  };

  // https://betterprogramming.pub/5-common-javascript-memory-mistakes-c8553972e4c2
  useEffect(() => () => window.cancelAnimationFrame(ticking), []);

  return [scrollElement, scrollXOffset, onScroll];
};

export default useHorizontalScrollHelpers;
